import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth, connectAuthEmulator } from "firebase/auth";

let cachedApp: FirebaseApp | null = null;
let cachedAuth: Auth | null = null;

export function firebaseApp(): FirebaseApp {
  if (cachedApp) return cachedApp;
  cachedApp = initializeApp({
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY!,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN!,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID!,
    appId: import.meta.env.VITE_FIREBASE_APP_ID!,
    // Optional — enables Firebase/Google Analytics (GA4) when set. Absent in
    // local dev by default; see .env.example.
    ...(import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
      ? { measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID }
      : {}),
  });
  return cachedApp;
}

export function firebaseAuth(): Auth {
  if (cachedAuth) return cachedAuth;
  cachedAuth = getAuth(firebaseApp());
  // Connect to the local Auth emulator only when explicitly opted in.
  // Default in dev is the emulator (preserves prior behavior); set
  // VITE_USE_EMULATORS=false in .env.local to log in against real Firebase Auth.
  const useEmulators =
    (import.meta.env.VITE_USE_EMULATORS ?? (import.meta.env.DEV ? "true" : "false")) === "true";
  if (useEmulators && window.location.hostname === "localhost") {
    try {
      connectAuthEmulator(cachedAuth, "http://127.0.0.1:9099", { disableWarnings: true });
    } catch (e) {
      // Emulator already connected
    }
  }
  return cachedAuth;
}
